import React from 'react';
const tones = ['bg-court', 'bg-night', 'bg-green-deep', 'bg-coral-deep', 'bg-court-deep'];

/** Fallback bonus cover, shown while no mockup image URL is set. */
export function BonusArt({
  number,
  title,
  index
}: {
  number: string;
  title: string;
  index: number;
}) {
  return <div className={`relative flex h-[230px] w-full items-center justify-center overflow-hidden sm:h-[265px] ${tones[index % tones.length]}`} role="img" aria-label={`${title} cover`} data-id="element-23" data-mp="1nq4tymyr61jj">
      <svg viewBox="0 0 400 260" className="absolute inset-0 h-full w-full" preserveAspectRatio="xMidYMid slice" aria-hidden="true" data-id="element-24" data-mp="2gf2buoz1xwbr">
        <g stroke="#FFFFFF" strokeOpacity="0.16" strokeWidth="2" fill="none" data-id="element-25" data-mp="2bn0skj3gv5c8">
          <rect x="30" y="20" width="340" height="220" data-id="element-26" data-mp="26pinx4whfca1" />
          <line x1="200" y1="10" x2="200" y2="250" strokeWidth="5" data-id="element-27" data-mp="26mwjhe4w1cw1" />
          <line x1="140" y1="20" x2="140" y2="240" data-id="element-28" data-mp="3454z8rs0ue41" />
          <line x1="260" y1="20" x2="260" y2="240" data-id="element-29" data-mp="2zdwpfums4qqc" />
          <line x1="30" y1="130" x2="140" y2="130" data-id="element-30" data-mp="2zc3j6gg2w8iv" />
          <line x1="260" y1="130" x2="370" y2="130" data-id="element-31" data-mp="14dtyd3kzqjcw" />
        </g>
      </svg>
      <div className="relative w-[64%] max-w-[240px] -rotate-3 rounded-xl bg-white p-4 shadow-card" data-id="element-32" data-mp="14fy5rvi3m0hx">
        <span className="block text-[10px] font-bold uppercase tracking-widest text-court" data-id="element-33" data-mp="19ehug3o2tqdz">Bonus {number}</span>
        <span className="mt-1.5 block font-display text-[15px] font-bold leading-snug text-ink" data-id="element-34" data-mp="zmlrae74va2w">{title}</span>
        <span className="mt-3 block h-1.5 w-3/4 rounded-full bg-panel" data-id="element-35" data-mp="lmksr5ecceql" />
        <span className="mt-1.5 block h-1.5 w-1/2 rounded-full bg-panel" data-id="element-36" data-mp="lpgoqo6motce" />
        <span className="mt-3 inline-block h-2 w-10 rounded-full bg-shuttle" data-id="element-37" data-mp="pq0lvrr7bwyj" />
      </div>
    </div>;
}